import { jsx as _jsx } from "react/jsx-runtime";
import { useNotifications } from '@/providers/NotificationsProvider';
import { cn } from '@/lib/cn';
export function NotificationsBadge({ className }) {
    const { unreadCount } = useNotifications();
    if (unreadCount === 0)
        return null;
    return (_jsx("span", { "aria-label": `${unreadCount} notificaciones sin leer`, className: cn('inline-flex h-5 min-w-5 items-center justify-center rounded-full', 'bg-red-500 px-1 text-xs font-bold text-white', className), children: unreadCount > 99 ? '99+' : unreadCount }));
}
//# sourceMappingURL=NotificationsBadge.js.map